import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@ib-shared/shared.module';

import { AuthHeaderComponent } from './_components/auth-header/auth-header.component';
import { AuthMenuComponent } from './_components/auth-header/auth-menu/auth-menu.component';
import { BreadcrumbsComponent } from './_components/auth-header/breadcrumbs/breadcrumbs.component';
import { NavComponent } from './_components/nav/nav.component';
import { AuthenticatedComponent } from './authenticated.component';
import { AuthenticatedRoutingModule } from './authenticated-routing.module';

@NgModule({
  imports: [CommonModule, SharedModule, AuthenticatedRoutingModule],
  declarations: [
    AuthenticatedComponent,
    NavComponent,
    AuthMenuComponent,
    BreadcrumbsComponent,
    AuthHeaderComponent,
  ],
})
export class AuthenticatedModule {}
